import { render, staticRenderFns } from "./PaperManagement.vue?vue&type=template&id=45c9cd55&scoped=true&"
import script from "./PaperManagement.vue?vue&type=script&lang=js&"
export * from "./PaperManagement.vue?vue&type=script&lang=js&"
import style0 from "./PaperManagement.vue?vue&type=style&index=0&id=45c9cd55&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c9cd55",
  null
  
)

export default component.exports